import React from 'react';

function deepObjectEqual(x: Record<string, any>, y: Record<string, any>): boolean {
  const ok = Object.keys, tx = typeof x, ty = typeof y;
  return x && y && tx === 'object' && tx === ty ? (
    ok(x).length === ok(y).length &&
      ok(x).every(key => deepObjectEqual(x[key], y[key]))
  ) : (x === y);
}


function isReactNodeEmpty(node: React.ReactNode): boolean {
  // nothing / booleans that don't render
  if (node === null || node === undefined || node === false) return true;

  // strings/numbers render (even "" renders nothing visually but it's still a node)
  if (typeof node === "string" || typeof node === "number") return false;

  // arrays/fragments: empty if all empty
  if (Array.isArray(node)) return node.every(isReactNodeEmpty);

  // React element: consider empty if *its own* children are empty
  if (React.isValidElement(node)) {
    return isReactNodeEmpty((node.props as any).children);
  }

  return false;
}

function oneLayerObjectEqual(x: any, y: any) {
  var keys = Object.keys(x);
  for(var i = 0; i < keys.length; i++) {
    var e = keys[i];
    if(y[e] !== x[e]) {
      return false;
    }
  }
  return true;
}

function fileTypeCheck(files: File[], types: string[]) {
  for(var i = 0; i < files.length; i++) {
    var file = files[i];
    var fileParts = file.name.split(".");
    const fileType = fileParts[fileParts.length - 1];
    if(!types.includes(fileType.toLowerCase())) {
        return false;
    }
  }
  return true;
}

function fileSizeCheck(files: File[], maxSizeInKB: number) {
  var maxSize = maxSizeInKB * 1000;
  for(var i = 0; i < files.length; i++) {
    var file = files[i];
    if(file.size > maxSize) return false;
  }
  return true;
}

// Generated Code
const formatEnumValue = (value: string): string => {
  return value
    .split("_") // Split by underscore
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
    .join(" "); // Join with a space
};

export {deepObjectEqual, fileTypeCheck, fileSizeCheck, oneLayerObjectEqual, formatEnumValue, isReactNodeEmpty}